import { render, staticRenderFns } from "./DefaultAside.vue?vue&type=template&id=76f37284&"
import script from "./DefaultAside.vue?vue&type=script&lang=js&"
export * from "./DefaultAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports